import { NgModule } from '@angular/core';

import { AnonymousResource } from './anonymous.resource';
import { ApplicationResource } from './application.resource';
import { AppointmentResource } from './appointment.resource';
import { ExpertizeResource } from './expertize.resource';
import { FileResource } from './file.resource';
import { PatientResource } from './patient.resource';
import { ProfessionalResource } from './professional.resource';
import { PatientFolderResource } from './patientFolder.resource';
import { PrebookResource } from './prebook.resource';
import { StructureMemberResource } from './structureMember.resource';
import { WlcontextResource } from './wlcontext.resource';
import { WlgoalResource } from './wlgoal.resource';
import { WldifficultyResource } from './wldifficulty.resource';

@NgModule({
  providers: [
    AnonymousResource,
    AppointmentResource,
    ApplicationResource,
    ExpertizeResource,
    FileResource,
    WlcontextResource,
    WlgoalResource,
    WldifficultyResource,
    PatientFolderResource,
    PrebookResource,
    ProfessionalResource,
    PatientResource,
    StructureMemberResource,
  ],
})
export class ResourcesModule {}
